import OrderClaims from 'pages/MyOrdersPage/OrderClaims/OrderClaims';
export default OrderClaims;
